import { render, staticRenderFns } from "./RequestDocumentShow.vue?vue&type=template&id=09c5d415&scoped=true&"
import script from "./RequestDocumentShow.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentShow.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocumentShow.vue?vue&type=style&index=0&id=09c5d415&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5d415",
  null
  
)

export default component.exports